const deepmerge = require('deepmerge')

const overwriteMerge = (destinationArray, sourceArray) => sourceArray

module.exports.deepmerge = function(target, source) {
  return deepmerge(target, source, { arrayMerge: overwriteMerge })
}
